import styled, { useTheme } from 'styled-components'
import { BsCheck } from 'react-icons/bs'

const CheckboxContainer = styled.div`
  width: 18px;
  height: 18px;
  border: 2px solid ${props => props.$borderColor};
  background-color: ${props => props.$backgroundColor};
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    border-color: ${props => props.theme.btn.primary};
  }
`

const CheckIcon = styled(BsCheck)`
  color: ${props => props.$color};
  font-size: 14px;
  font-weight: bold;
  margin: 0;
`

const SelectionCheckbox = ({ state, onChange, disabled = false }) => {
  const theme = useTheme()
  
  const getCheckboxStyle = () => {
    switch (state) {
      case 'selected':
      case 'all':
        return {
          backgroundColor: theme.btn.primary,
          borderColor: theme.btn.primary,
          color: '#fff'
        }
      case 'some':
        return {
          backgroundColor: 'transparent',
          borderColor: theme.btn.primary,
          color: theme.btn.primary
        }
      default:
        return {
          backgroundColor: 'transparent',
          borderColor: theme.area.lightBorder,
          color: 'transparent'
        }
    }
  }

  const style = getCheckboxStyle()

  const handleClick = (e) => {
    e.preventDefault()
    e.stopPropagation()
    if (!disabled && onChange) {
      onChange({ shiftKey: e.shiftKey })
    }
  }

  return (
    <CheckboxContainer 
      onClick={handleClick}
      $backgroundColor={style.backgroundColor}
      $borderColor={style.borderColor}
      style={{ opacity: disabled ? 0.5 : 1, cursor: disabled ? 'not-allowed' : 'pointer' }}
    >
      {(state === 'selected' || state === 'some' || state === 'all') && (
        <CheckIcon $color={style.color} />
      )}
    </CheckboxContainer>
  )
}

export default SelectionCheckbox
